export default "__VITE_ASSET__CZ16VS9i__"